'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/dots/DotsIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DotsIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.0003 10.8333C10.4606 10.8333 10.8337 10.4602 10.8337 9.99996C10.8337 9.53972 10.4606 9.16663 10.0003 9.16663C9.54009 9.16663 9.16699 9.53972 9.16699 9.99996C9.16699 10.4602 9.54009 10.8333 10.0003 10.8333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.8753 10.8333C17.3356 10.8333 17.7087 10.4602 17.7087 9.99996C17.7087 9.53972 17.3356 9.16663 16.8753 9.16663C16.4151 9.16663 16.042 9.53972 16.042 9.99996C16.042 10.4602 16.4151 10.8333 16.8753 10.8333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M3.12533 10.8333C3.58556 10.8333 3.95866 10.4602 3.95866 9.99996C3.95866 9.53972 3.58556 9.16663 3.12533 9.16663C2.66509 9.16663 2.29199 9.53972 2.29199 9.99996C2.29199 10.4602 2.66509 10.8333 3.12533 10.8333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.12533 9.79163C3.01027 9.79163 2.91699 9.8849 2.91699 9.99996C2.91699 10.115 3.01027 10.2083 3.12533 10.2083C3.24038 10.2083 3.33366 10.115 3.33366 9.99996C3.33366 9.8849 3.24038 9.79163 3.12533 9.79163ZM1.66699 9.99996C1.66699 9.19454 2.31991 8.54163 3.12533 8.54163C3.93074 8.54163 4.58366 9.19454 4.58366 9.99996C4.58366 10.8054 3.93074 11.4583 3.12533 11.4583C2.31991 11.4583 1.66699 10.8054 1.66699 9.99996ZM10.0003 9.79163C9.88527 9.79163 9.79199 9.8849 9.79199 9.99996C9.79199 10.115 9.88527 10.2083 10.0003 10.2083C10.1154 10.2083 10.2087 10.115 10.2087 9.99996C10.2087 9.8849 10.1154 9.79163 10.0003 9.79163ZM8.54199 9.99996C8.54199 9.19454 9.19491 8.54163 10.0003 8.54163C10.8057 8.54163 11.4587 9.19454 11.4587 9.99996C11.4587 10.8054 10.8057 11.4583 10.0003 11.4583C9.19491 11.4583 8.54199 10.8054 8.54199 9.99996ZM16.8753 9.79163C16.7603 9.79163 16.667 9.8849 16.667 9.99996C16.667 10.115 16.7603 10.2083 16.8753 10.2083C16.9904 10.2083 17.0837 10.115 17.0837 9.99996C17.0837 9.8849 16.9904 9.79163 16.8753 9.79163ZM15.417 9.99996C15.417 9.19454 16.0699 8.54163 16.8753 8.54163C17.6807 8.54163 18.3337 9.19454 18.3337 9.99996C18.3337 10.8054 17.6807 11.4583 16.8753 11.4583C16.0699 11.4583 15.417 10.8054 15.417 9.99996Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

export {
  DotsIcon
};
//# sourceMappingURL=chunk-GOOKMKZ7.mjs.map